import React, { useState } from 'react';
import QrReader from 'react-qr-scanner';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import { useAuth } from '../context/AuthContext'; // Asegúrate de importar useAuth
import '../styles/QrScannerComponent.css';

const CartCode = () => {
  const navigate = useNavigate();
  const { token } = useAuth(); // Obtener el token del contexto
  const [lastScannedCode, setLastScannedCode] = useState(null);
  const [cartData, setCartData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [scanKey, setScanKey] = useState(0); // Estado para forzar el reinicio del escáner

  const handleScan = async (data) => {
    if (!data || data.text === lastScannedCode) return;

    const scannedCode = data.text.trim();
    setLastScannedCode(scannedCode);

    try {
      // Asegurarse de que la URL esté correctamente interpolada
      const apiUrl = `${API_BASE}/cart-details?cart_code=${scannedCode}`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`, // Agregar el token en los headers
        },
      });

      // Verificar si la respuesta es válida JSON
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) {
        const result = await response.json();

        if (response.ok) {
          if (result.cart_code && result.cart_status === 'in_use') {
            const cartType = result.cart_code.startsWith('BASKET') ? 'Frío' : 'Abarrote';
            setCartData({
              type: cartType,
              poNumber: result.po_numbers,
              client: result.client,
              responsibilities: result.order_responsibilities,
            });
            setErrorMessage(null); // Clear any previous error message
          }
        } else {
          // Manejar errores del servidor
          if (result.error === 'Cart is not in use.') {
            setErrorMessage('No se encuentra en uso.');
            setCartData(null);
          } else if (result.error === 'Cart not found.') {
            setErrorMessage('Error al leer el código.');
            setCartData(null);
          } else {
            setErrorMessage('Ocurrió un error inesperado. Intenta de nuevo.');
            setCartData(null);
          }
        }
      } else {
        // Si la respuesta no es JSON, maneja el error
        setErrorMessage('Error al obtener los datos. Respuesta no válida.');
        setCartData(null);
      }
    } catch (error) {
      console.error('Error en la solicitud:', error);
      setErrorMessage('Error al conectar con el servidor. Intenta de nuevo.');
      setCartData(null);
    }
  };

  const handleError = (err) => {
    console.error('Error al escanear:', err);
  };

  // Función para borrar los datos y permitir un nuevo escaneo
  const handleRestartScan = () => {
    setLastScannedCode(null);
    setCartData(null);
    setErrorMessage(null);
    setScanKey((prevKey) => prevKey + 1); // Cambiar la clave para forzar el reinicio del escáner
  };

  return (
    <div className="qrscanner-container">
      <button onClick={() => navigate('/picking')} className="qrscanner-back-button">
        &#8592;
      </button>

      <h1 className="qrscanner-title">Escanea un Abarrote/Frío</h1>

      <div className="qrscanner-video-container">
        <QrReader
          key={scanKey} // Usar la clave para reiniciar el componente
          delay={500}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '100%' }}
          constraints={{
            video: {
              facingMode: 'environment', // Fuerza usar la cámara trasera
            },
          }}
        />
      </div>

      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {cartData && (
  <div className="cart-info-container">
    <h2 className="cart-info-title">Información</h2>
    <div className="cart-info-details">
      <p><strong>Tipo:</strong> {cartData.type}</p>
      <p><strong>PO Número:</strong> {cartData.poNumber}</p>
      <p><strong>Cliente:</strong> {cartData.client}</p>
      <p><strong>Responsables:</strong></p>
      <ul className="cart-responsibles-list">
        {cartData.responsibilities.map((responsible, index) => (
          <li key={index} className="responsible-item">{responsible}</li>
        ))}
      </ul>
    </div>
  </div>
)}


      {/* Botón para volver a escanear, siempre visible independientemente de error o éxito */}
      <button onClick={handleRestartScan} className="qrscanner-restart-button">
        Volver a escanear
      </button>
    </div>
  );
};

export default CartCode;
